export default __webpack_public_path__ + "static/media/persistencia_pol.fd1eb431.png";